import React, { useState, useEffect } from 'react';
import { Image } from 'antd';
import * as THREE from 'three';
import { assetChanged } from '@src/components/scene/editor/components/lib/asset-changed';
const BasePath = 'https://d23hwblhugcea5.cloudfront.net/Global/StudioTextures/';

const TEXTURES = [
  `${BasePath}Walls+/1.jpg`,
  `${BasePath}Walls+/2.jpg`,
  `${BasePath}Walls+/3.jpg`,
  `${BasePath}Walls+/4.jpg`,
  `${BasePath}Psych/1.jpg`,
  `${BasePath}Psych/2.jpg`,
  `${BasePath}Psych/3.jpg`,
  `${BasePath}Psych/4.jpg`,

  `${BasePath}Floors/1.jpg`,
  `${BasePath}Floors/2.jpg`,
  `${BasePath}Floors/3.jpg`,
  `${BasePath}Floors/4.jpg`,

  `${BasePath}Basic/1.jpg`,
  `${BasePath}Basic/2.jpg`,
  `${BasePath}Basic/3.jpg`,
  `${BasePath}Basic/4.jpg`,

  `${BasePath}Wood/TX_Denzel_2_Normal.jpg`,
];

export const getTexture = (url) => {
  return new THREE.TextureLoader().load(url);
};

const changeTexture = ({ texture, object }) => {
  if (texture) {
    const newTexture = getTexture(texture); // Ruta de la nueva textura
    object.traverse((child: any) => {
      if (child.isMesh) {
        let cloneMaterial = child.material.clone();
        cloneMaterial.map = newTexture;
        cloneMaterial.needsUpdate = true;
        child.material = cloneMaterial;
      }
    });
  }
};

export default function ChangeTextureComponent({
  selectedModel,
  selectedModelProps,
  dispatchChangeModels,
  setSelectedModelProps,
}) {
  const objectRef = selectedModel.props.asset.ref.current;

  useEffect(() => {}, [selectedModel]);

  return (
    <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
      <p style={{ margin: 0 }}>Change Texture</p>

      <div style={{ display: 'flex', gap: '30px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            flexWrap: 'wrap',
            padding: '.5em',
          }}
        >
          {TEXTURES.map((item, key) => {
            return (
              <img
                style={{
                  flex: '1',
                  maxWidth: '70px',
                  cursor: 'pointer',
                }}
                key={`img-texture-${key}`}
                src={item}
                alt='Texture preview'
                onClick={() => {
                  const newProps = {
                    ...selectedModelProps,
                  };

                  const prevProps = {
                    ...selectedModelProps,
                  };

                  newProps.textureToChange = item;
                  prevProps.textureToChange =
                    selectedModel.props.asset.textureToChange;
                  if (assetChanged(prevProps, newProps, true)) {
                    dispatchChangeModels({
                      type: 'change',
                      newData: newProps,
                      prevProps,
                      elementId: selectedModel.props.asset.ref.current.uuid,
                    });
                    selectedModel.props.asset.textureToChange = item;

                    changeTexture({ texture: item, object: objectRef });
                    setSelectedModelProps(() => newProps);
                  }
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
